import React from 'react';
import { useClientUser } from '@/hooks';
import DocumentPanel from '../Documents/DocumentPanel';

/** The account's un-archived documents, resolved from UserContext. */
const CustomDocuments = ({ bare = false }) => {
    const { user_id } = useClientUser();

    return <DocumentPanel clientId={user_id} archived={false} bare={bare} />;
};

export default CustomDocuments;
